import { useEffect, useState, useSyncExternalStore } from 'react'
import { getPendingWrites, subscribePendingWrites } from '../utils/syncTracker'

function subscribeOnline(listener: () => void): () => void {
  window.addEventListener('online', listener)
  window.addEventListener('offline', listener)
  return () => {
    window.removeEventListener('online', listener)
    window.removeEventListener('offline', listener)
  }
}

export function useOnline(): boolean {
  return useSyncExternalStore(subscribeOnline, () => navigator.onLine, () => true)
}

/**
 * offline: ingen forbindelse.
 * unsynced: der er ændringer, som serveren ikke har bekræftet efter et øjeblik.
 */
export function useSyncStatus(): { online: boolean; unsynced: boolean } {
  const online = useOnline()
  const pending = useSyncExternalStore(subscribePendingWrites, getPendingWrites, () => 0)
  const [unsynced, setUnsynced] = useState(false)

  useEffect(() => {
    if (pending === 0) {
      setUnsynced(false)
      return
    }
    // Korte, normale gem vises ikke — kun når det trækker ud.
    const timer = window.setTimeout(() => setUnsynced(true), 1500)
    return () => window.clearTimeout(timer)
  }, [pending])

  return { online, unsynced: pending > 0 && unsynced }
}
